import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { Inter, Playfair_Display } from 'next/font/google'

const inter = Inter({
    variable: '--font-sans',
    subsets: ['latin'],
    weight: ['400', '500', '600'],
    display: 'swap'
})

const playfair = Playfair_Display({
    variable: '--font-serif',
    subsets: ['latin'],
    weight: ['400'],
    display: 'swap'
})

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className={`${inter.variable} ${playfair.variable} h-full font-sans antialiased`}>
            <Component {...pageProps} />
        </div>
    )
}

export default App
